import jwtDecode from 'jwt-decode';
import { DecodedUserToken, GigyaResponseType } from './types';
import { CountryUtils } from '@xarvio/frontend-core-platform/lib/country/CountryUtils';

export const GIGYA_INCORRECT_PASSWORD_CODE = 403042;

export const getGigyaErrorMessage = (response: GigyaResponseType) => {
  if (response.errorCode === 0) {
    return undefined;
  }

  switch (response.errorCode) {
    // User disabled in GIGYA
    case 403041: {
      return {
        reason: 'GIGYA',
        message: 'general.gigya.accountDisabled',
      };
    }

    // Token expired
    case 403025: {
      return {
        errorCode: 403025,
        reason: 'GIGYA',
        message: 'general.gigya.invalidToken',
      };
    }

    // Unauthorized user
    case 403005: {
      return {
        reason: 'GIGYA',
        message: 'general.gigya.unauthorizedUser',
      };
    }

    // Incorrect login/pass pair
    case GIGYA_INCORRECT_PASSWORD_CODE: {
      return {
        reason: 'GIGYA',
        message: 'general.gigya.incorrectPassword',
      };
    }

    // Reset password link expired
    case 400006: {
      return {
        reason: 'GIGYA',
        message: 'general.gigya.resetPasswordLinkExpired',
      };
    }

    //Account Temporarily Locked Out : occured because, attempts exceeded
    case 403120: {
      return {
        reason: 'GIGYA',
        message: 'general.gigya.invalidNumberOfAttempts',
      };
    }

    // All other problems
    default: {
      return {
        reason: 'TECH',
        message: response.errorMessage,
      };
    }
  }
};

export const emptyDecodedToken: DecodedUserToken = {
  iat: 0,
  exp: 0,
  sub: '',
  uuid: '',
  features: [],
  country: '',
  language: '',
  external: false,
  jti: '',
};

export const decodeToken = (token: string): DecodedUserToken => {
  try {
    const parsed: DecodedUserToken = jwtDecode(token);

    return {
      iat: parsed.iat,
      exp: parsed.exp,
      sub: parsed.sub,
      uuid: parsed.uuid,
      features: parsed.features,
      country: parsed.country,
      language: parsed.language,
      external: parsed.external,
      jti: parsed.jti,
    };
  } catch {
    return emptyDecodedToken;
  }
};

export const isTokenExpired = (decodedToken: DecodedUserToken) => {
  return decodedToken.exp < Date.now() / 1000;
};

export const smartSprayerCountries = [CountryUtils.COUNTRY.BRAZIL];
